const MAX_ITEMS_SHOW = 7;
const MIDDLE_SECTION_COUNT = 3;
const SHOW_MIDDLE_SECTION_COUNT = 4;
const END_COUNT_ITEMS = 4;

const SEPARATOR = '...';

const CURRENT_POSITION_MAP = {
  START: 'start',
  END: 'end',
  MIDDLE: 'middle',
};

export const getPaginationPagesList = ({
  total,
  currentPage,
  perPage,
}: {
  total?: number;
  perPage?: number;
  currentPage: number;
}) => {
  if (!total || !perPage) return [];

  const pagesCount = Math.ceil(total / perPage);

  if (pagesCount <= MAX_ITEMS_SHOW) {
    return new Array(pagesCount).fill(null).map((_, index) => index + 1);
  }
  const pages: (number | string)[] = [1];

  let currentPagePosition: string;

  if (currentPage <= SHOW_MIDDLE_SECTION_COUNT) {
    currentPagePosition = CURRENT_POSITION_MAP.START;
  } else if (pagesCount - currentPage > MIDDLE_SECTION_COUNT) {
    currentPagePosition = CURRENT_POSITION_MAP.MIDDLE;
  } else {
    currentPagePosition = CURRENT_POSITION_MAP.END;
  }

  switch (currentPagePosition) {
    case CURRENT_POSITION_MAP.START:
      for (let i = 1; i <= SHOW_MIDDLE_SECTION_COUNT; i++) {
        pages.push(i + 1);
      }

      pages.push(SEPARATOR, pagesCount);
      break;
    case CURRENT_POSITION_MAP.MIDDLE:
      pages.push(SEPARATOR, currentPage - 1, currentPage, currentPage + 1);
      pages.push(SEPARATOR, pagesCount);
      break;
    case CURRENT_POSITION_MAP.END:
      pages.push(SEPARATOR);
      let restPages = pagesCount - END_COUNT_ITEMS;

      while (restPages <= pagesCount) {
        pages.push(restPages);
        restPages++;
      }
      break;
    default:
      break;
  }

  return pages;
};
